
export function getActiveToken () {
    const env = window.envStore;
    return env.authStore.token;
}

export function getActiveAPIKey () {
    const env = window.envStore;
    return env.authStore.apiKey;
}

export function getHeaderOption () {
    const env = window.envStore;
    return {
        token: env.authStore.token,
        traceId: env.traceId,
    };
}

export function getStore (key) {
    const env = window.envStore;
    const map = {
        errors: env.errorsStore,
        auth: env.authStore,
    };
    
    if (map[key]) {
        return map[key];
    }
    return env[key];
}

export function extendExpiration () {
    // const auth = getStore('auth');
    // auth.extendExpiration();
}

export function urlEncodedParams (p) {
    const state = JSON.stringify(p.state);
    let pstr = '';
    for (let key in p) {
        if (key === 'state') {
            continue;
        }
        if (pstr !== '') {
            pstr = `${pstr}&`;
        }
        const value = p[key];
        if (key === 'scope') {
            pstr = `${pstr}${key}=${value}`;
            continue;
        }
        
        pstr = `${pstr}${key}=${encodeURIComponent(value)}`;
    }
    pstr = `${pstr}&state=${encodeURIComponent(state)}`;
    return pstr;
}

export function getRedirectURL () {
    const redirects = {
        local: 'localhost:2090',
        // local: 'testing-oauth.ecal.com',
        test: 'testing-oauth.ecal.com',
        stage: 'staging-oauth.ecal.com',
        // stage: 'localhost',
        prod: 'oauth.ecal.com',
    };

    const env = getEnv();
    if (env && redirects[env]) {
        return redirects[env];
    }
    
    return redirects.prod;
}

export function getOauthClientID (settings, params) {
    // change base on environment?
    let id = settings.defaultIds.prod;
    if (window.env) {
        id = settings.defaultIds[window.env];
        const clients = settings.clients[window.env];
        if (clients && clients[params.publisherId]) {
            id = clients[params.publisherId];
        }
    }
    return id;
}

export function getEnv () {
    return window.env;
}

export function animationsStore () {
    return window.env.animationsStore;
}
